import { Route, Routes } from 'react-router-dom';
import FaqListPage from './list';
import FaqDetailPage from './detail';
import CreateBlogPage from './create';

export default function FaqRouting() {
  return (
    <Routes>
      <Route index element={<FaqListPage />} />
      <Route path="/create" element={<CreateBlogPage />} />
      <Route path="/:id" element={<FaqDetailPage />} />
    </Routes>
  );
}
